import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

import 'dayjs/locale/en'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'
import 'dayjs/locale/nl'
import 'dayjs/locale/pl'
import 'dayjs/locale/es'
import 'dayjs/locale/it'
import 'dayjs/locale/pt'
import 'dayjs/locale/ca'

const DefaultLocale = 'en'

export default defineNuxtPlugin(() => {
  dayjs.locale(DefaultLocale)
  dayjs.extend(utc)
  dayjs.extend(timezone)
  dayjs.tz.setDefault('Europe/Paris')

  return {
    provide: {
      dayjs
    }
  }
})
